// extracted by mini-css-extract-plugin
export default {"importCsvCard":"AddProd_importCsvCard__TqcB3","addProductBtnContainer":"AddProd_addProductBtnContainer__4aPI+"};